import { render, staticRenderFns } from "./AccreditationsLoading.vue?vue&type=template&id=77e87b8c&"
import script from "./AccreditationsLoading.ts?vue&type=script&lang=ts&"
export * from "./AccreditationsLoading.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports